import type { SerializedStyles, Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint } from '@twistopayments/design-system/styles'

import type { ToastVariant } from './toast.context'

export const box = (theme: Theme) => css`
  display: grid;
  position: relative;
  align-items: center;
  border-top-left-radius: ${theme.borderRadius.md};
  border-bottom-left-radius: ${theme.borderRadius.md};
  grid-template-columns: ${theme.spacing[24]} auto;
  column-gap: ${theme.spacing[8]};
  padding: ${theme.spacing[12]};

  ${breakpoint.up('sm')} {
    grid-template-columns: ${theme.spacing[32]} auto;
    column-gap: ${theme.spacing[16]};
    padding: ${theme.spacing[24]};
  }
`

export const variants: Record<ToastVariant, (theme: Theme) => SerializedStyles> = {
  success: (theme: Theme) => css`
    background: ${theme.palette.primary.lowContrast};
  `,
  warning: (theme: Theme) => css`
    background: ${theme.palette.warning.mediumContrast};
  `,
  info: (theme: Theme) => css`
    background: ${theme.palette.tertiary.lowContrast};
  `,
  error: (theme: Theme) => css`
    background: ${theme.palette.error.mediumContrast};
  `,
}

export const button = (theme: Theme) => css`
  display: flex;
  position: absolute;
  outline: 0;
  border: none;
  background: transparent;
  top: 0;
  right: 0;
  padding: ${theme.spacing[8]};
  cursor: pointer;
  pointer-events: all;
`
